import script from "./PreViewImg.vue?vue&type=script&lang=ts&setup=true"
export * from "./PreViewImg.vue?vue&type=script&lang=ts&setup=true"

import "./PreViewImg.vue?vue&type=style&index=0&id=d5b7f138&lang=scss"

const __exports__ = script;

export default __exports__